module.exports = __webpack_public_path__ + "static/img/9.eeaf6ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/zh/9.png
// module id = QYLe
// module chunks = 0